/**
 * Shared environment detection utilities
 *
 * INFO: Using globalThis instead of typeof window === 'undefined' to work around
 * a Storybook bug with @storybook/nextjs-vite where typeof window incorrectly
 * returns 'undefined' even though window exists.
 *
 * @see https://github.com/storybookjs/storybook/issues/32028
 */
export const isBrowser =
  typeof globalThis !== 'undefined' && 'window' in globalThis;
